module.exports = __webpack_public_path__ + "img/SN.e44eea63.png";